<template>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="card shadow-sm bg-light">
        <form
          class="my-0 py-0"
          autocomplete="off"
          method="POST"
          @submit.prevent="onSubmit"
        >
          <div class="card-header text-dark text-center text-lg">
            แจ้งถอนค่าแนะนำ
          </div>
          <div class="card-body">
            <span class="text-md text-danger">* ถอนค่าแนะนำขั้นต่ำ 500</span>
            <div class="form-group">
              <input
                :id="elementId"
                :type="elementType"
                :name="elementName"
                class="form-control w-100 text-xl text-center border-success"
                onfocus="{ this.value = ''; }"
                :placeholder="elementPlaceholder"
                :value="amount"
                @class="elementClass"
                @paste="onPaste($event)"
                @keypress="validateNumber($event)"
                @keyup="updateAmount($event)"
              />
            </div>
          </div>
          <div class="card-footer text-center">
            <div class="row py-2">
              <div class="col-6">
                <button class="btn w-100 text-lg btn-dark" type="reset">
                  ยกเลิก
                </button>
              </div>
              <div class="col-6">
                <button class="btn w-100 text-lg btn-success" type="submit">
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="affs" class="col-12 mb-3 table-responsive">
      <h4 class="my-1">ประวัติการถอนค่าแนะนำ</h4>
      <table class="table table-striped">
        <tr v-for="aff in affs" :key="aff.id" class="">
          <td class="text-left">
            <h4>ถอน</h4>
            <small>
              <convert-thaidate :date="aff.created_at" />
            </small>
          </td>
          <td class="text-primary text-lg text-right">
            -{{ aff.amount }} <small>แต้ม</small>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "AffInput",
  props: {
    urlWithdraw: {
      type: String,
      default: "",
    },
    urlAffreport: {
      type: String,
      default: "",
    },
    elementName: {
      type: String,
      default: "",
    },
    elementId: {
      type: String,
      default: "",
    },
    elementType: {
      type: String,
      default: "",
    },
    elementLabel: {
      type: String,
      default: "",
    },
    elementTitle: {
      type: String,
      default: "",
    },
    elementClass: {
      type: String,
      default: "",
    },
    elementPlaceholder: {
      type: String,
      default: "",
    },
    userId: {
      type: [Number, String],
    },
  },

  data() {
    return {
      amount: "",
      affs: [],
    };
  },

  mounted() {
    self = this;

    axios
      .post(this.urlAffreport, { user_id: this.userId })
      .then((response) => {
        self.affs = response.data;
      })
      .catch((error) => {});
  },

  methods: {
    validateNumber: (evt) => {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateAmount(evt) {
      let val = evt.target.value;
      if (val == "NaN" || val == "") {
        val = 0;
      }
      this.amount = val;
    },
    onPaste: (evt) => {
      evt.preventDefault();
    },
    onSubmit() {
      self = this;
      let postUrl;
      postUrl = this.urlWithdraw;
      axios
        .post(postUrl, { amount: this.amount })
        .then((response) => {
          Vue.$toast.open({
            message: "ถอนค่าแนะนำสำเร็จ",
            type: "success",
            duration: 1000,
            position: "top-right",
          });
          self.amount = "";
        })
        .catch((error) => {
          let message = "";
          if (error.response.status == 406) {
            if (error.response.data.message == "Not sufficient funds") {
              message = "ค่าแนะนำไม่เพียงพอ กรุณาตรวจสอบ";
            } else if (error.response.data.message == "amount lower") {
              message = "ถอนค่าแนะนำขั้นต่ำ 500";
            }
          } else if (error.response.status == 429) {
            message = "คุณทำรายการเกินกำหนด";
          } else {
            message = "ผิดพลาด ลองใหม่อีกครั้ง";
          }
          Vue.$toast.open({
            message,
            type: "error",
            duration: 1000,
            position: "top-right",
          });
          self.amount = "";
        });
      axios
        .post(this.urlAffreport, { user_id: this.userId })
        .then((response) => {
          self.affs = response.data;
        })
        .catch((error) => {});
    },
  },
};
</script>
